import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { injectIntl, defineMessages } from 'react-intl';
import { intlShape } from '../../../../../components/prop-types';

const i18n = defineMessages({
  showHints: { id: 'actions.showHints', defaultMessage: 'Show hints' },
  addNew: { id: 'attrs.addNew', defaultMessage: 'Add new' },
});


const HintsHeader = (props) => {
  const {
    onHints, onShowAddForm, children, isShow,
    intl: { formatMessage },
  } = props;
  return (
    <div className="p-grid p-nogutter">
      <div className="p-col">
        <Button
          icon={isShow ? 'pi pi-eye' : 'pi pi-eye-slash'}
          className={isShow ? '' : 'p-button-secondary'}
          onClick={onHints}
          tooltip={formatMessage(i18n.showHints)}
          tooltipOptions={{ position: 'bottom' }}
        />
        {' '}
        {children}
      </div>

      {onShowAddForm && (
        <div className="p-col-2 align-right">
          <Button
            icon="fa fa-plus-circle"
            type="button"
            className="p-button-secondary"
            data-t="cs-action-add"
            onClick={onShowAddForm}
            tooltip={formatMessage(i18n.addNew)}
            tooltipOptions={{ position: 'bottom' }}
          />
        </div>
      )}
    </div>
  );
};

HintsHeader.propTypes = {
  intl: intlShape.isRequired,
  children: PropTypes.objectOf(PropTypes.any).isRequired,
  onShowAddForm: PropTypes.func,
  onHints: PropTypes.func.isRequired,
  isShow: PropTypes.bool.isRequired,
};

HintsHeader.defaultProps = {
  onShowAddForm: null,
};

export default injectIntl(HintsHeader);
